import React from "react";
import { Link } from "react-router-dom";
import { LegalPage, LegalSection, LegalIntro, LegalList, LegalAddress } from "../../components/LegalPage";

/* Verbatim from Dr_Tania_Approved_Legal_Page_Copy_2026-08-03.md.
 * Section 12: the exact phrase "Privacy & Consent Policy" is linked to /privacy. */

export default function Terms() {
  return (
    <LegalPage
      title="Terms of Use"
      effectiveDate="Effective date: 3 August 2026"
      seoTitle="Terms of Use | Dr Tania Gurdip Singh"
      seoDescription="These Terms govern the use of drtaniasingh.com. By accessing or using the website, you agree to these Terms."
      canonical="/terms"
    >
      <LegalIntro>
        <p>These Terms govern the use of drtaniasingh.com.</p>
        <p>
          By accessing or using the website, you agree to these Terms. Where you do not
          agree, please discontinue use of the website.
        </p>
      </LegalIntro>

      <LegalSection n={1} title="Website operator">
        <p>
          This website is operated by Dr Tania Gurdip Singh, practising through HIGH RISKK
          PREGNANCY CLINIC.
        </p>
      </LegalSection>

      <LegalSection n={2} title="Purpose of the website">
        <p>The website provides:</p>
        <LegalList items={[
          "General educational information about pregnancy and high-risk pregnancy",
          "Conditions, Articles and Clinical Insights",
          "Information about Dr Tania’s professional background",
          "A facility to request a consultation",
          "A facility to submit general pregnancy questions for editorial consideration",
          "Contact and clinic information",
        ]}/>
        <p>
          The website is not an emergency service, diagnostic platform or substitute for
          individual medical care.
        </p>
      </LegalSection>

      <LegalSection n={3} title="No doctor–patient relationship from website use">
        <p>
          Reading the website, submitting a form, receiving an automated acknowledgement or
          sending a general question does not establish a doctor–patient relationship.
        </p>
        <p>
          A professional relationship begins only after a consultation has been accepted and
          conducted in an appropriate clinical setting.
        </p>
      </LegalSection>

      <LegalSection n={4} title="Consultation requests">
        <p>A submitted consultation request is an enquiry only.</p>
        <p>It does not guarantee:</p>
        <LegalList items={[
          "Appointment availability",
          "A particular consultation date",
          "Acceptance of a case",
          "A specific consultation format",
          "A particular treatment or outcome",
        ]}/>
        <p>The team will contact you regarding availability and the next steps.</p>
        <p>
          In-person consultations may be offered in New Delhi or Ambala as currently
          indicated. The appropriate format for a teleconsultation is coordinated
          individually.
        </p>
        <p>
          Fees, payment arrangements, rescheduling and cancellation conditions, where
          applicable, will be communicated separately before or during appointment
          coordination.
        </p>
      </LegalSection>

      <LegalSection n={5} title="Ask a Question">
        <p>The Ask a Question page is intended for general educational questions.</p>
        <p>Questions:</p>
        <LegalList items={[
          "Are not answered individually as medical consultations",
          "Are not published automatically",
          "May not receive a response",
          "May be edited for clarity",
          "May be combined with similar questions",
          "May be anonymised and used in future Articles or Clinical Insights",
        ]}/>
        <p>Do not include names, reports, photographs, prescriptions or identifying medical details.</p>
        <p>
          By submitting a question with the required consent, you permit us to review, edit,
          anonymise and use its substance for educational purposes without an obligation to
          publish or attribute it.
        </p>
      </LegalSection>

      <LegalSection n={6} title="Emergency situations">
        <p>
          The website and its forms are not monitored continuously and must not be used for
          emergencies.
        </p>
        <p>
          Where you have urgent symptoms or concerns, seek immediate medical care through an
          appropriate hospital or emergency service.
        </p>
      </LegalSection>

      <LegalSection n={7} title="Appropriate use">
        <p>You agree not to:</p>
        <LegalList items={[
          "Submit false, misleading or impersonated information",
          "Upload malicious code",
          "Attempt unauthorised access",
          "Interfere with website security or availability",
          "Harvest information from the website",
          "Submit abusive, defamatory, unlawful or threatening content",
          "Use the website to advertise or distribute spam",
          "Copy or republish substantial website content without permission",
          "Present educational content as personalised medical advice",
        ]}/>
        <p>We may restrict access or remove submissions where necessary for safety, security or lawful operation.</p>
      </LegalSection>

      <LegalSection n={8} title="Intellectual property">
        <p>
          Unless stated otherwise, the website’s text, design, branding, original educational
          content, Articles and Clinical Insights are owned by or licensed to Dr Tania Gurdip
          Singh.
        </p>
        <p>
          Content may be read, shared through ordinary links and printed in limited form for
          personal education.
        </p>
        <p>
          It may not be reproduced, republished, commercially distributed, systematically
          copied, modified or presented under another person’s name without prior written
          permission.
        </p>
        <p>
          Book covers, journal references, professional-body names and external materials
          remain the property of their respective owners.
        </p>
      </LegalSection>

      <LegalSection n={9} title="Accuracy and availability">
        <p>
          Reasonable efforts are made to provide accurate and useful information. Medicine
          and clinical guidance can change, and individual circumstances differ.
        </p>
        <p>We do not guarantee that:</p>
        <LegalList items={[
          "Every page will always be current",
          "Every service will always be available",
          "The website will operate without interruption",
          "Every link will remain active",
          "General information will apply to a particular individual",
        ]}/>
        <p>The website may be updated, suspended or changed without prior notice.</p>
      </LegalSection>

      <LegalSection n={10} title="Third-party links">
        <p>
          Links to third-party websites are provided for reference or convenience. Their
          inclusion does not imply control over or endorsement of every statement, service or
          policy on those websites.
        </p>
      </LegalSection>

      <LegalSection n={11} title="Limitation of responsibility">
        <p>
          You remain responsible for seeking appropriate professional assessment before
          acting on health information.
        </p>
        <p>
          To the extent permitted by law, Dr Tania Gurdip Singh and HIGH RISKK PREGNANCY
          CLINIC are not responsible for loss arising solely from reliance on general website
          information in place of individual medical advice.
        </p>
        <p>Nothing in these Terms excludes liability or consumer rights that cannot lawfully be excluded.</p>
      </LegalSection>

      <LegalSection n={12} title="Privacy">
        <p>
          Use of personal information is governed by the website’s{" "}
          <Link
            to="/privacy"
            data-testid="terms-privacy-link"
            className="text-navy underline underline-offset-4 decoration-prestige hover:text-prestige"
          >
            Privacy &amp; Consent Policy
          </Link>
          .
        </p>
      </LegalSection>

      <LegalSection n={13} title="Governing law">
        <p>These Terms are governed by the laws of India.</p>
        <p>
          Subject to rights and remedies available under applicable consumer law, disputes
          relating to the website will be subject to the jurisdiction of competent courts in
          New Delhi, India.
        </p>
      </LegalSection>

      <LegalSection n={14} title="Contact">
        <p>Questions about these Terms may be sent to:</p>
        <LegalAddress>
          <strong>HIGH RISKK PREGNANCY CLINIC</strong><br/>
          A-78A, Veer Savarkar Marg<br/>
          Opposite SBI Bank, Lajpat Nagar II<br/>
          New Delhi – 110024<br/>
          <strong>Email: privacy@drtaniasingh.com</strong>
        </LegalAddress>
      </LegalSection>
    </LegalPage>
  );
}
